import { useEffect } from 'react';

/**
 * Tracks the pointer and writes its eased position into CSS custom
 * properties `--mx` and `--my` on the document root.
 * No-ops on touch-only devices.
 */
export function useCursor(): void {
  useEffect(() => {
    const supportsHover = window.matchMedia?.('(hover: hover)').matches;
    if (!supportsHover) return;

    const root = document.documentElement;
    let raf = 0;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const tick = () => {
      currentX += (targetX - currentX) * 0.15;
      currentY += (targetY - currentY) * 0.15;
      root.style.setProperty('--mx', `${currentX}px`);
      root.style.setProperty('--my', `${currentY}px`);

      const dx = Math.abs(targetX - currentX);
      const dy = Math.abs(targetY - currentY);
      raf = dx > 0.3 || dy > 0.3 ? requestAnimationFrame(tick) : 0;
    };

    const onMove = (event: PointerEvent) => {
      targetX = event.clientX;
      targetY = event.clientY;
      if (!raf) raf = requestAnimationFrame(tick);
    };

    window.addEventListener('pointermove', onMove);
    return () => {
      window.removeEventListener('pointermove', onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
}
